import angular from 'angular';

class NavigationService {
    constructor(
        $filter,
        $q,
        navigationConstants,
        userAccessService,
        sessionService,
        sessionTypeConstants
    ) {
        this.$filter = $filter;
        this.$q = $q;
        this.navigationConstants = navigationConstants;
        this.userAccessService = userAccessService;
        this.sessionService = sessionService;
        this.sessionTypeConstants = sessionTypeConstants;

        this.items = {};
        this.settingsItems = [];
        this.selected = this.items[0];
        this.selectedSubState = {};
    }

    getNavigationItems() {
        const deferred = this.$q.defer();

        if (
            this.sessionService.getSessionType() ==
            this.sessionTypeConstants.guest
        ) {
            var access = this.userAccessService.getGuestUserAccess();

            Object.keys(this.navigationConstants).map(k => {
                if (access.indexOf(this.navigationConstants[k].sref) > -1) {
                    this.items[k] = this.navigationConstants[k];
                }
            });
            deferred.resolve(this.items);

            return deferred.promise;
        }

        this.userAccessService.getUserAccess().then(data => {
            Object.keys(this.navigationConstants).map(k => {
                if (data.indexOf(this.navigationConstants[k].sref) > -1) {
                    this.items[k] = this.navigationConstants[k];
                }
            });
            deferred.resolve(this.items);
        }, deferred.reject);

        return deferred.promise;
    }

    getSettingsNavigationItems() {
        const deferred = this.$q.defer();

        this.userAccessService.getUserAccess().then(data => {
            this.settingsItems = [];
            Object.keys(this.navigationConstants.settings.subNavigation).map(
                k => {
                    if (
                        data.indexOf(
                            this.navigationConstants.settings.subNavigation[k]
                                .sref
                        ) > -1
                    ) {
                        this.settingsItems.push(
                            this.navigationConstants.settings.subNavigation[k]
                        );
                    }
                }
            );
            deferred.resolve(this.settingsItems);
        }, deferred.reject);

        return deferred.promise;
    }

    getSettingsDefaultRedirectionState() {
        const deferred = this.$q.defer();

        this.getSettingsNavigationItems().then(data => {
            let defaultRedirectionState = '';
            if (data != undefined && data.length > 0) {
                defaultRedirectionState = data[0].sref;
            }
            deferred.resolve(defaultRedirectionState);
        }, deferred.reject);

        return deferred.promise;
    }

    setSelectedState(state) {
        this.getNavigationItems().then(
            () => {
                if (state.name == 'license_overview') {
                    this.selected = this.items.main;
                    return;
                }

                this.selected = this.items[state.parent] || this.items[0];

                if (
                    this.selected &&
                    this.selected.subNavigation &&
                    this.selected.subNavigation.length > 0
                ) {
                    const subNavigation = this.$filter('filter')(
                        this.selected.subNavigation,
                        {
                            sref: state.name
                        }
                    );
                    if (subNavigation != null && subNavigation.length > 0) {
                        this.selectedSubState = subNavigation[0];
                    }
                }
            },
            () => {}
        );
    }
}

angular.module('shared').service('navigationService', NavigationService);



// WEBPACK FOOTER //
// ./modules/shared/services/navigation/navigation.service.js